<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import store from './stores/index';
export default {
  name: 'App',
  data () {
    return {
      user: {}
    };
  },
  methods: {
    setDefault () {
      if (process.env.NODE_ENV === 'development') {
        store.commit('setDev', true);
      }
      let resize = function () {
        if (window.innerWidth < 1200) {
          document.querySelector('[name="viewport"]').setAttribute('content', 'width=1200,initial-scale=1.0');
        } else {
          document.querySelector('[name="viewport"]').setAttribute('content', 'width=device-width,initial-scale=1.0');
        }
      };
      document.addEventListener('resize', resize, false);
      resize();

      let doAjaxBeforeUnloadEnabled = true;

      let doAjaxBeforeUnload = function (evt) {
        if (!doAjaxBeforeUnloadEnabled) {
          return;
        }
        doAjaxBeforeUnloadEnabled = false;
        doAjaxBeforeUnloadEnabled = true;
        return '';
      };

      window.onpagehide = doAjaxBeforeUnload;
      window.onbeforeunload = doAjaxBeforeUnload;
    }
  },
  created () {
    this.setDefault();
  }
};
</script>

<style lang="stylus">
  *
    box-sizing border-box
  * img
    user-select none !important
  .area *
    user-select none !important
  select
    appearance none
    border 1px solid #aaaaaa
    padding 9px 10px
    border-radius 3px
    font-size 16px
  select::-ms-expand
    display none
  textarea,
  input[type="number"],
  input[type="email"],
  input[type="text"]
    border 1px solid #aaaaaa
    padding 9px 10px
    border-radius 3px
    font-size 16px
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button
    -webkit-appearance none !important
    margin 0 !important
  input[type="number"]
    -moz-appearance textfield !important
  h1,h2,h3,h4,h5
    padding 0
    margin 0
  ul,li,dl,dt,dd,figure
    list-style none
    margin 0
    padding 0
  button,a,label
    cursor pointer
    border none
    background-color transparent
    outline none
    &:hover
      opacity 0.7
  body
    margin 0
    padding 0
    overflow hidden
    width 100%
    height 100%
    position absolute
    left 0
    top 0
    font-family: 'Noto Sans JP', sans-serif;
  #app
    /*font-family 'Avenir', Helvetica, Arial, sans-serif*/
    -webkit-font-smoothing antialiased
    -moz-osx-font-smoothing grayscale
    color #333333
    margin 0
    padding 0
    overflow hidden
    width 100%
    height 100%
    position absolute
    left 0
    top 0
</style>



// WEBPACK FOOTER //
// src/App.vue